import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Button, Image, Modal } from "antd";
import "./AddMerchandise.css";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import useRetail from "../../../hooks/useRetail";
import { useBookingData } from "../../../context/BookingDataContext";

const AddMerchandise = ({ setUpdatedMerchandise }) => {
    const { bookingData, setBookingData } = useBookingData()
    const [materials, setMaterials] = useState([]);
    const [filteredMaterials, setFilteredMaterials] = useState([]);
    const [filteredType, setFilteredType] = useState("All");
    const { getMerchandiseData } = useRetail();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMerchandiseLoaded, setIsMerchandiseLoaded] = useState(false);
    const [selectedSizes, setSelectedSizes] = useState({});
    
    const visiblemerchandise = materials.slice(0, 4);

    useEffect(() => {
        const fetchMaterials = async () => {
            const data = await getMerchandiseData();
            if (data) {
                const previousMerchandiseDetails = bookingData?.updatedmerchandiseDetails?.merchandise || [];
                const formattedMaterials = data.map((merchandise) => {
                    const existingMerchandise = previousMerchandiseDetails.find(
                        (item) => item.merchandiseId === merchandise._id
                    );
    
                    return {
                        id: merchandise._id,
                        name: merchandise.name,
                        desc: merchandise.desc,
                        type: merchandise.type,
                        price: merchandise.price,
                        image: merchandise.mediaId.key,
                        count: existingMerchandise ? existingMerchandise.count : 0,
                        // size: merchandise.size,
                    };
                });
    
                setMaterials(formattedMaterials);
                setFilteredMaterials(formattedMaterials);
                setIsMerchandiseLoaded(true);
            }
        };

        (async () => {
            await fetchMaterials();
        })();
    }, [bookingData.updatedmerchandiseDetails, getMerchandiseData])

    useEffect(() => {
        if (!isMerchandiseLoaded) return;

        const merchandiseDetails = materials
            .filter(material => material.count > 0)
            .map(material => ({
                merchandiseId: material.id,
                merchandiseName: material.name,
                merchandiseType: material.type,
                count: material.count,
                size: selectedSizes[material.id] || null,
                price: material.price,
                totalPrice: material.count * material.price
            }));
    
        const merchandiseTotal = merchandiseDetails.reduce((sum, item) => sum + item.totalPrice, 0);
        const merchandiseCount = materials.reduce((total, material) => total + material.count, 0);
    
        if (merchandiseDetails.length > 0) {
            setBookingData((prevData) => ({
                ...prevData,
                updatedmerchandiseDetails: {
                    merchandiseCount: merchandiseCount,
                    merchandise: merchandiseDetails,
                    merchandiseTotal: merchandiseTotal
                },
            }));
            setUpdatedMerchandise({
                merchandiseCount: merchandiseCount,
                merchandise: merchandiseDetails,
                merchandiseTotal: merchandiseTotal
            });
        } else {
            setUpdatedMerchandise({
                merchandiseCount: 0,
                merchandise: [],
                merchandiseTotal: 0
            });

            setBookingData((prevData) => ({
                ...prevData,
                updatedmerchandiseDetails: {
                    merchandiseCount: 0,
                    merchandise: [],
                    merchandiseTotal: 0
                }
            }))
        }
    }, [materials, setUpdatedMerchandise, setBookingData]);    

    const materialTypes = ["All", ...new Set(materials.map((material) => material.type))];

    const filteredMaterial =
        filteredType === "All"
            ? materials
            : materials.filter((material) => material.type === filteredType);

    const handleIncrement = (id) => {
        setMaterials((prevMaterials) =>
            prevMaterials.map((material) =>
                material.id === id ? { ...material, count: material.count + 1 } : material
            )
        );
    };

    const handleDecrement = (id) => {
        setMaterials((prevMaterials) =>
            prevMaterials.map((material) =>
                material.id === id && material.count > 0 ? { ...material, count: material.count - 1 } : material
            )
        );
    };

    const handleShowMore = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <Container className="my-5 add-merchan-container">
            <div className='pb-3 text-mob'>
                <h4 className='fs-28 fw-700 text-black'>
                    Add your merchandise
                </h4>
            </div>
            <Row 
                className="d-flex align-items-center justify-content-center"
                style={{ borderRadius: '24px', backgroundColor: '#FFFF', border: '1px solid #A0A1AB' }}    
            >
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='px-0'>                    
                    <Row className="m-3 pb-4 merchandise-content" style={{ backgroundColor: '#fff', borderRadius: '16px' }}>
                        {visiblemerchandise.map((material) => (
                            <Col key={material.id} xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>                              
                                <div className="d-flex align-items-center py-3 booking-border-bottom">
                                    <div className='me-3'>
                                        <Image
                                            src={material.image}
                                            alt={`${material.type} icon`}
                                            preview={false}
                                            className="merchan-food-img"
                                            style={{ objectFit: "cover", borderRadius: "16px", }}
                                        />
                                    </div>
                                    <div>
                                        <h5 className="fs-16 fw-600 text-black mb-1">
                                            {material.name}
                                        </h5>

                                        {/* {material.size && material.size.length > 0 && (
                                            <div className="d-flex gap-2 flex-wrap mb-2">
                                                {material.size.map((size, index) => (
                                                    <Button
                                                        key={index}
                                                        className={`px-3 py-1 fw-600 rounded-pill ${
                                                            selectedSizes[material.id] === size ? 'selected-size' : ''
                                                        }`}
                                                        onClick={() => {
                                                            setSelectedSizes(prev => ({ ...prev, [material.id]: size }));
                                                        }}
                                                        type={selectedSizes[material.id] === size ? 'primary' : 'default'}
                                                    >
                                                        {size}
                                                    </Button>
                                                ))}
                                            </div>
                                        )} */}

                                        <h6 className="fs-18 fw-700 text-black">
                                            ₹{material.price.toFixed(2)} x {material.count}
                                        </h6>
                                    </div>
                                    <div 
                                        className="d-flex align-items-center justify-content-end merchandise-button ms-auto"
                                        style={{ border: "1px solid black", borderRadius: "28px", padding: "5px 20px" }}
                                    >
                                        <span
                                            // onClick={() => handleDecrement(material.id)}
                                            className="fw-700 fs-12 p-1 text-black"
                                            style={{ cursor: "pointer" }}
                                        >
                                            <MinusOutlined />
                                        </span>

                                        <span className="fw-700 fs-18 p-1 text-black">
                                            {material.count}
                                        </span>

                                        <span
                                            // onClick={() => handleIncrement(material.id)}
                                            className="fw-700 fs-12 p-1 text-black"
                                            style={{ cursor: "pointer" }}
                                        >
                                            <PlusOutlined />
                                        </span>
                                    </div>
                                </div>
                            </Col>
                        ))}
                        <div className='d-flex justify-content-end mt-3'>
                            <Button
                                type="default"
                                className="fs-16 fw-600 booking-btn"
                                style={{borderColor: '#272727'}}
                                size="large"
                                // onClick={handleShowMore}
                            >
                                Show More
                            </Button>
                        </div>
                    </Row>
                </Col>
            </Row>

            <Modal 
                title='All Merchandise Item' 
                open={isModalOpen} 
                onCancel={handleCloseModal} 
                footer={null} 
                width={700}
                className='merchandise-modal'
            >               
                <div className="my-3 merchan-content">
                    {materialTypes.map((type) => (
                        <Button
                            key={type}
                            type="default"
                            size="large"
                            className={`fs-14 fw-700 booking btn m-2 ${
                                filteredType === type ? "text-white" : "text-black"
                            }`}
                            style={{
                                backgroundColor: filteredType === type ? "#000" : "transparent",
                                borderColor: "#000",
                                borderRadius: "28px",
                                padding: "0 2rem",
                            }}
                            onClick={() => setFilteredType(type)}
                        >
                            {type}
                        </Button>
                    ))}
                </div>

                <div className="pb-3" style={{ overflowY: 'auto', maxHeight: '400px', overflowX: 'hidden'}}>
                    <Row>
                        {filteredMaterial.map((material) => (
                            <Col key={material.id} xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>                              
                                <div className="d-flex align-items-center py-3 booking-border-bottom">
                                    <div className='me-3'>
                                        <Image
                                            src={material.image}
                                            alt={`${material.type} icon`}
                                            preview={false}
                                            className="merchan-food-img"
                                            style={{ objectFit: "cover", borderRadius: "16px", }}
                                        />
                                    </div>
                                    <div>
                                        <h5 className="fs-16 fw-600 text-black mb-1">
                                            {material.name}
                                        </h5>

                                        {/* {material.size && material.size.length > 0 && (
                                            <div className="d-flex gap-2 flex-wrap mb-2">
                                                {material.size.map((size, index) => (
                                                    <Button
                                                        key={index}
                                                        className={`px-3 py-1 fw-600 rounded-pill ${
                                                            selectedSizes[material.id] === size ? 'selected-size' : ''
                                                        }`}
                                                        onClick={() => {
                                                            setSelectedSizes(prev => ({ ...prev, [material.id]: size }));
                                                        }}
                                                        type={selectedSizes[material.id] === size ? 'primary' : 'default'}
                                                    >
                                                        {size}
                                                    </Button>
                                                ))}
                                            </div>
                                        )} */}

                                        <h6 className="fs-18 fw-700 text-black">
                                            ₹{material.price.toFixed(2)} x {material.count}
                                        </h6>
                                    </div>
                                    <div 
                                        className="d-flex align-items-center justify-content-end merchandise-button ms-auto"
                                        style={{ border: "1px solid black", borderRadius: "28px", padding: "5px 20px" }}
                                    >
                                        <span
                                            // onClick={() => handleDecrement(material.id)}
                                            className="fw-700 fs-12 p-1 text-black"
                                            style={{ cursor: "pointer" }}
                                        >
                                            <MinusOutlined />
                                        </span>

                                        <span className="fw-700 fs-18 p-1 text-black">
                                            {material.count}
                                        </span>

                                        <span
                                            // onClick={() => handleIncrement(material.id)}
                                            className="fw-700 fs-12 p-1 text-black"
                                            style={{ cursor: "pointer" }}
                                        >
                                            <PlusOutlined />
                                        </span>
                                    </div>
                                </div>
                            </Col>                              
                        ))}
                        <div className="d-flex justify-content-end">
                            <Button
                                type="primary"
                                className="fs-16 fw-600 booking-btn"
                                size="large"
                                onClick={handleCloseModal}
                            >
                                Continue
                            </Button>
                        </div>
                    </Row>
                </div>
            </Modal>
        </Container>
    );
};

export default AddMerchandise;
